/* eslint-disable max-len */

import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import ICO_TICK from 'assets/images/icons/tick-black.svg';
import SalonModal from 'components/dialog/SalonModal.component';
import SalonButton from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import { withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonId } from 'selectors/currentSalon.selectors';
import isNilValue from 'utils/predicates/any/isNilValue.util';

import ConfirmationModalComponent from 'common/PopupModal';
import { clearError, deleteRole } from 'onboarding/roles/actions';
import AddRole from 'onboarding/roles/AddRole.component';
import RoleFieldContainer from 'onboarding/roles/RoleField';
import Button from 'settings/page-elements/Button';
import RoleDropdown from 'settings/roles/RoleDropdown';

import CN from './RolesScreen.module.scss';

export class RolesScreen extends React.Component {
  static defaultProps = {
    hideAddBtn: false,
    addBtnDisabled: false,
    isPosting: false,
    showSaved: false,
    addRoleBtn: () => {},
    editRoleSaveBtn: () => {},
  };

  constructor(props) {
    super(props);
    this.state = {
      editedRolesMap: [],
      enabledBtnsMap: [],
      roleName: '',
      saveBtnEnabled: false,
      showDeleteRolePopup: false,
      deleteMessage: '',
      showCopyModal: false,
      selectedRoleId: null,
    };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    const rolesIdsToRemove = this.props.editedRolesIds.filter((id) => nextProps.editedRolesIds.indexOf(id) === -1);
    const rolesIdsToAdd = nextProps.editedRolesIds.filter((id) => this.props.editedRolesIds.indexOf(id) === -1);

    const editedRolesMap = this.state.editedRolesMap.slice(0);
    const enabledBtnsMap = this.state.enabledBtnsMap.slice(0);

    rolesIdsToRemove.forEach((id) => {
      editedRolesMap[id] = null;
    });

    rolesIdsToAdd.forEach((id) => {
      const role = this.props.roles.find((r) => r.id === id);
      editedRolesMap[id] = Object.assign({}, role);
      enabledBtnsMap[id] = true;
    });

    this.setState({ editedRolesMap, enabledBtnsMap });
    if (nextProps.deleteMessage) {
      this.setState({ showDeleteRolePopup: true, deleteMessage: nextProps.deleteMessage });
    }
  }

  onEditHandler = (name, id) => {
    this.props.onDotMenuEditClick(name, id);
  };
  onDeleteHandler = (id) => {
    this.props.deleteRole(id, this.props.id);
  };
  onRoleNameChange = (value) => {
    let enabled = false;
    if (value.replace(/\s/g, '').length > 0) {
      enabled = true;
    }
    this.setState({ roleName: value, saveBtnEnabled: enabled });
  };
  onEditRoleNameChange = (value, id) => {
    let enabled = false;
    if (value.replace(/\s/g, '').length > 0) {
      enabled = true;
    }

    if (this.state.editedRolesMap[id]) {
      const editedRolesMap = this.state.editedRolesMap.slice(0);
      const enabledBtnsMap = this.state.enabledBtnsMap.slice(0);
      editedRolesMap[id].name = value;
      enabledBtnsMap[id] = enabled;
      this.setState({ editedRolesMap, enabledBtnsMap });
    }
  };

  copyRole = (roleId) => {
    if (this.props.addRoleBtn) {
      this.props.addRoleBtn(this.state.roleName, roleId);
    }
    this.setState({ selectedRoleId: null });
    setTimeout(() => {
      this.props.getCategories(this.props.id);
    }, 1000);
  };

  handleConfirmClick = () => {
    const { selectedRoleId } = this.state;
    if (selectedRoleId !== null) {
      this.copyRole(selectedRoleId);
    }
    this.setState({ showCopyModal: false });
  };

  addRoleClick = (tf) => {
    this.setState({ showCopyModal: tf });
  };

  handleRoleSelect = (roleId) => {
    this.setState({ selectedRoleId: roleId });
  };

  hideDeleteRolePopup = () => {
    this.setState({ showDeleteRolePopup: false, deleteMessage: '' });
    this.props.clearError();
  };

  render() {
    const { selectedRoleId, showCopyModal } = this.state;
    const { roles, t } = this.props;

    return (
      <div data-bem="RolesScreen" className="content  auto-height obs-role">
        <label htmlFor="rankSelector">
          <div className={CN.subTitle}>{t('composite.rolesScreen.subTitle')}</div>

          <div id="rankSelector">
            {roles.length > 0 && (
              <div className="online-booking">
                {roles.map((role) => {
                  const isEdited = this.props.editedRolesIds.indexOf(role.id) !== -1;
                  const isSaved = this.props.settingsSavedRolesIDs.filter((saved) => saved.id === role.id).length !== 0;
                  const error = this.props.settingsErrorRolesIDs.find((e) => e.id === role.id);

                  if (!isEdited) {
                    return (
                      <div className="relative" key={role.id}>
                        <RoleFieldContainer
                          roleName={role.name}
                          id={role.id}
                          isSaved={this.props.showSaved && isSaved}
                          errorMessage={error && error.message}
                          deleteError={this.state.deleteMessage}
                          onEditHandler={this.onEditHandler}
                          onDeleteHandler={this.onDeleteHandler}
                        />
                        <TooltipForReceptionist where={IN.jobs} />
                      </div>
                    );
                  }
                  return (
                    <div key={role.id} className="obs-role-component">
                      {/* Hidden in onboarding and visible in booking settings */}
                      <Button
                        buttonName={
                          this.props.isPosting ? (
                            t('common.saving')
                          ) : (
                            <img src={ICO_TICK} alt="Tick" className={CN.imgButtonTick} />
                          )
                        }
                        onClickButton={() => {
                          if (this.props.editRoleSaveBtn) {
                            this.props.editRoleSaveBtn(this.state.editedRolesMap[role.id]);
                          }
                        }}
                        className="item-button-more obs-save-button hidden"
                        disabled={
                          this.props.isPosting || !this.state.enabledBtnsMap[role.id] || this.props.addBtnDisabled
                        }
                      />
                      <AddRole
                        onRoleNameChange={(value) => {
                          this.onEditRoleNameChange(value, role.id);
                        }}
                        roleName={role.name}
                      />
                      {/*  Visible in onboarding and  Hidden in booking settings */}

                      <Button
                        buttonName={this.props.isPosting ? t('common.saving') : t('common.buttons.add')}
                        onClickButton={() => {
                          if (this.props.editRoleSaveBtn) {
                            this.props.editRoleSaveBtn(this.state.editedRolesMap[role.id]);
                          }
                        }}
                        className="btn-fix-width m-t-15 onboarding-button"
                        disabled={
                          this.props.isPosting || !this.state.enabledBtnsMap[role.id] || this.props.addBtnDisabled
                        }
                      />
                    </div>
                  );
                })}
              </div>
            )}
            {!this.props.hideAddBtn && (
              <div className="online-booking">
                <div className="rounded-border-wrap dashed obs-button">
                  <div className="online-booking" style={{ paddingTop: 40 }}>
                    <div className="relative">
                      <button onClick={this.props.onAddRoleClick} className="btn btn-violet">
                        {t('composite.rolesScreen.addButton')}
                      </button>
                      <TooltipForReceptionist where={IN.btnAddJob} />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {this.props.hideAddBtn && (
              <div className="online-booking">
                <div className="add-new-screen">
                  <button
                    className="close-btn hidden"
                    onClick={(e) => {
                      e.stopPropagation();
                      this.props.onAddRoleClick();
                    }}
                  />
                  <AddRole onRoleNameChange={this.onRoleNameChange} />
                  <Button
                    buttonName={this.props.isPosting ? t('common.saving') : t('common.buttons.add')}
                    onClickButton={() => this.addRoleClick(true)}
                    className="btn-fix-width m-t-15"
                    disabled={this.props.isPosting || !this.state.saveBtnEnabled || this.props.addBtnDisabled}
                  />
                </div>
              </div>
            )}

            {this.state.showDeleteRolePopup && (
              <ConfirmationModalComponent
                popupTitle={t('composite.rolesScreen.confirmationModal.title')}
                popupMessage={t('composite.rolesScreen.confirmationModal.popupMessage')}
                buttonText={t('common.buttons.okay')}
                buttonCallback={this.hideDeleteRolePopup}
              />
            )}
          </div>
        </label>

        <SalonModal tag="RolesScreen__modal-new-role" isOpen={showCopyModal} withFooter>
          <SalonModal.Header>
            <div className={CN.closeButtonContainer}>
              <SalonButton variant="empty" onClick={() => void this.setState({ showCopyModal: false })}>
                <Icon variant="close" variantInvert />
              </SalonButton>
            </div>
          </SalonModal.Header>
          <SalonModal.Body>
            <div className={CN.modalContent}>
              <IconStatus variant="info" width="lg" position="left">
                <Icon variant="newspaper" width="l1" selected />
              </IconStatus>
              <div className={CN.modalTitle}>{t('composite.rolesScreen.copyServicesModal.title')}</div>
              <RoleDropdown roles={roles} onRoleSelect={this.handleRoleSelect} />
            </div>
          </SalonModal.Body>
          <SalonModal.Footer>
            <SalonButton
              variant="primaryForce"
              xSpace
              onClick={this.handleConfirmClick}
              disabled={isNilValue(selectedRoleId)}
            >
              {t('composite.rolesScreen.copyServicesModal.confirmButton')}
            </SalonButton>
          </SalonModal.Footer>
        </SalonModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state.onboarding.roles,
  id: selectCurrentSalonId(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ deleteRole, clearError }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(RolesScreen));
